export default __webpack_public_path__ + "static/media/facebook.9a1368f0.svg";